module.exports = {
  LOGIN: '/login',
  GETSIGNEDURL: '/signedurl',
  SMARTTHON: '/smartthon/{smartthonId}',
  ENTERPRISE: '/enterprise',
  SUGGESTION: '/suggestion/{enterpriseId}/{smartthonId}/{studentId}',
  NOTIFICATION: '/notification/{notificationId}',
  INTERN: '/intern/{internId}',
  SKILL: '/skill/{skillId}',
  CONTACT: '/contact/{conversationId}',
  MASTER: '/master',
  SWIPE: '/swipe/{swipeId}',
  STUDENT: '/student/{studentId}',
  PLAN: '/enterprise/plan'
}



// WEBPACK FOOTER //
// ./src/store/api.js